import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  UtilityText,
  Checkbox,
  FormField,
  TextInput,
  Fieldset,
} from '@leagueplatform/genesis-core';
import { FraudModal } from '../../../layout/fraudModal';
import { updateFormData } from '../../../helpers';

export function ConsentInformation(props: any) {
  const { errorHandling, ubk, nextButtonClicked, footerToBottom } = props;

  const [form, setForm] = useState({
    patientConsent: false,
    paymentAuthorization: false,
    entityName: '',
  });

  const [isFraudError, setIsFraudError] = useState(false);
  const [fraudError, setFraudError] = useState('');

  const isValid = form.patientConsent;
  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);
  useEffect(() => {
    if (form.patientConsent) {
      errorHandling(true);
    } else {
      errorHandling(false);
    }
  }, [errorHandling, form]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        if (!form.patientConsent) {
          setIsFraudError(true);
          setFraudError('This selection is required.');
        }
      }
    }
  }, [nextButtonClicked, isValid, form]);

  const onUpdate = (e: any) => {
    const { id, value, checked } = e.target;
    if (id === 'entityName') {
      const nextFormState = {
        ...form,
        [id]: value,
      };
      setForm(nextFormState);
    } else {
      const nextFormState = {
        ...form,
        [id]: checked,
      };
      setForm(nextFormState);
      if (id === 'patientConsent') {
        setIsFraudError(false);
        setFraudError('');
      }
    }
  };

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm({
        patientConsent: pInfo?.patientConsent,
        paymentAuthorization: pInfo?.paymentAuthorization,
        entityName: pInfo?.entityName || '',
      });
    }
  }, []);

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <HeadingText
          level="1"
          size={{
            '@initial': 'xxl',
            '@mobile': 'xl',
            '@mobileLandscape': 'xl',
            '@tablet': 'xl',
            '@laptop': 'xxl',
            '@desktop': 'xxl',
          }}
          data-testid="dentalheading"
        >
          Member Dental Claim Form
        </HeadingText>
        <Box
          css={
            {
              marginTop: '$two',
              marginBottom: '$one',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="3"
            size={{
              '@initial': 'xl',
              '@mobile': 'lg',
              '@mobileLandscape': 'lg',
              '@tablet': 'xl',
              '@laptop': 'xl',
              '@desktop': 'xl',
            }}
            data-testid="step6"
          >
            Step 6: Patient Consent
          </HeadingText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              paddingBottom: '$two',
            } as GDSStyleObject
          }
        >
          <UtilityText>
            I have been informed of the treatment plan and associated fees. I
            agree to be responsible for all charges for dental services and
            materials not paid by my dental benefit plan, unless prohibited by
            law, or the treating dentist or dental practice has a contractual
            agreement with my plan prohibiting all or a portion of such charges.
          </UtilityText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
            } as GDSStyleObject
          }
        >
          <UtilityText>
            To the extent permitted by law, I consent to your use and disclosure
            of my protected health information to carry out payment activities
            in connection with this claim.
          </UtilityText>
        </Box>
        <Box>
          <FraudModal fraudLabel="Fraud and discrimination disclaimers" />
        </Box>
        {ubk !== '9001' && ubk !== '9002' && ubk !== '6002' && (
          <Box>
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Payment Authorization (Optional)
            </HeadingText>
            <UtilityText
              css={
                {
                  display: 'flex',
                  paddingTop: '$one',
                } as GDSStyleObject
              }
            >
              <Checkbox
                id="paymentAuthorization"
                name="payment-authorization"
                label=""
                data-testid="paymentAuthorization"
                checked={form.paymentAuthorization}
                onChange={(e) => onUpdate(e)}
              />
              I hereby authorize and direct payment of the dental benefits
              otherwise payable to me, directly to the below named dentist or
              dental entity.
            </UtilityText>

            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$one',
                } as GDSStyleObject
              }
            >
              <FormField id="entityName" label="Dentist/Dental Entity’s Name">
                <TextInput
                  value={form.entityName}
                  data-testid="inputField"
                  onChange={(e) => onUpdate(e)}
                />
              </FormField>
            </Box>
          </Box>
        )}
        <Box>
          <FormField
            id="fraudAcknowledgement"
            label=""
            statusIconLabel="Error"
            data-testid="patientConsent"
            inputStatus={isFraudError ? 'error' : undefined}
            statusMessage={isFraudError ? fraudError : ''}
          >
            <Fieldset
              css={
                {
                  display: 'flex',
                } as GDSStyleObject
              }
              legend={undefined}
            >
              <Checkbox
                id="patientConsent"
                name="patient-consent"
                label=""
                checked={form.patientConsent}
                // data-testid="patientConsent"
                onChange={(e) => onUpdate(e)}
              />
              <span style={{ paddingTop: '7px' }}>
                By{' '}
                <span style={{ fontWeight: 'bold' }}>
                  checking this box and clicking “Submit”
                </span>{' '}
                below, I am{' '}
                <span style={{ fontWeight: 'bold' }}>
                  electronically signing
                </span>{' '}
                this Dental Claim Form. I am in agreement with the above and
                certify that the information provided on this claim form is
                correct and complete.
              </span>
            </Fieldset>
          </FormField>
        </Box>
      </Box>
    </StackLayout>
  );
}
